var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08622 18.4391C9.64122 18.8057 10.3571 18.8057 10.9112 18.4391C12.6737 17.2757 16.5112 14.4949 18.1646 11.3832C20.3437 7.27825 17.7845 3.18408 14.4012 3.18408C12.4729 3.18408 11.3129 4.19158 10.6712 5.05742C10.5941 5.16346 10.4931 5.24976 10.3763 5.30927C10.2595 5.36877 10.1302 5.39979 9.99914 5.39979C9.86804 5.39979 9.73881 5.36877 9.622 5.30927C9.50519 5.24976 9.40412 5.16346 9.32705 5.05742C8.68538 4.19158 7.52538 3.18408 5.59705 3.18408C2.21372 3.18408 -0.345447 7.27825 1.83455 11.3832C3.48622 14.4949 7.32539 17.2757 9.08622 18.4391Z",
    fill: "#FF7A00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigHeart);
export default __webpack_public_path__ + "static/media/big_heart.4f328298da3785932596751731344aae.svg";
export { ForwardRef as ReactComponent };